import { DottedKey } from '../../../core/field-definitions/entities/field-definition.entity';
import { Comparable } from '../../../helpers/entities/comparable.interface';
import { Trackable } from '../../../helpers/entities/trackable.interface';
import { SortType } from '../../generic-overview/components/display-settings-bar/entities/sort-type.entity';
import { Cell } from '../components/cells/_base/table-cell.entity';
import { ColumnWidth } from './column-width.entity';

export interface ColumnOptions<T, P> {
    readonly key: keyof T | string;
    readonly translateLabel: string;
    readonly mapper: (item: P) => Cell;
    readonly width?: ColumnWidth;
    readonly headerHidden?: boolean;
    readonly sortable?: boolean;
    readonly sortType?: SortType;
    readonly fieldSelectDottedKeys?: DottedKey[];
}
export class ColumnDef<T, P extends Trackable & Comparable> implements ColumnOptions<T, P> {
    key: string | keyof T;
    translateLabel: string;
    mapper: (item: P) => Cell;
    width: ColumnWidth;
    headerHidden: boolean;
    fieldSelectDottedKeys: DottedKey[];
    sortable: boolean;
    sortType: SortType;

    constructor(columnOptions: ColumnOptions<T, P>) {
        this.key = columnOptions.key;
        this.translateLabel = columnOptions.translateLabel;
        this.mapper = columnOptions.mapper;
        this.width = columnOptions.width ?? ColumnWidth.NORMAL;
        this.headerHidden = columnOptions.headerHidden ?? false;
        this.fieldSelectDottedKeys = columnOptions.fieldSelectDottedKeys ?? [];
        this.sortable = columnOptions.sortable ?? false;
        this.sortType = columnOptions.sortType ?? SortType.GENERIC;
    }

    toString(): string {
        return this.key.toString();
    }
}
